import { Text } from "@alpacahq/ui/old";

import type { FAQItem } from "../../../../../components/common/FAQ";

export const DOCUMENTS_FAQ: FAQItem[] = [
  {
    question: "What is a Business Registration Document?",
    answer: (
      <div className="flex flex-col gap-3">
        <Text className="font-light text-gray-800 text-sm">
          A business registration document is an official certificate or record
          issued by a government authority to confirm that a business has been
          legally registered with that government authority.
        </Text>
        <Text className="font-light text-gray-800 text-sm">
          For US businesses, this is usually a State Authority. It typically
          includes essential details like:
        </Text>
        <ul className="ml-1 list-disc pl-4 text-sm">
          <li>
            <span className="font-medium">Business name</span>
          </li>
          <li>
            <span className="font-medium">Registration number</span>
          </li>
          <li>
            <span className="font-medium">Business type </span>(LLC, sole
            proprietorship, etc.)
          </li>
          <li>
            <span className="font-medium">Date of registration</span>
          </li>
        </ul>
      </div>
    ),
  },
  {
    question: "What is a Company Formation Document?",
    answer: (
      <div className="flex flex-col gap-3">
        <Text className="font-light text-gray-800 text-sm">
          A Company Formation Document is a legal document filed with the
          government to officially establish a business entity. It typically
          contains details about the company's structure, operations, and key
          stakeholders. These documents vary by country and business type.
        </Text>
        <Text className="font-light text-gray-800 text-sm">
          Common Examples:
        </Text>
        <ul className="ml-1 list-disc pl-4 text-sm">
          <li>
            <span className="font-medium">Articles of Incorporation</span>: For
            corporations in the U.S.
          </li>
          <li>
            <span className="font-medium">Articles of Organization</span>: For
            LLCs in the U.S.
          </li>
          <li>
            <span className="font-medium">
              Memorandum and Articles of Association (M&A)
            </span>
            : For companies in the U.K.
          </li>
          <li>
            <span className="font-medium">Deed of Incorporation</span>: In some
            European countries
          </li>
        </ul>
        <Text className="font-light text-gray-800 text-sm">
          These documents often include the company name, purpose, registered
          address, share structure, and details about directors and
          shareholders. They are essential for legal recognition and compliance.
        </Text>
      </div>
    ),
  },
  {
    question: "What is a Business Operating Document?",
    answer: (
      <div className="flex flex-col gap-3">
        <Text className="font-light text-gray-800 text-sm">
          A Business Operating Document outlines the internal rules, processes,
          and structure for managing a company. It helps define how decisions
          are made, responsibilities are assigned, and business operations are
          conducted. The specific type of document can vary depending on the
          business structure.
        </Text>
        <Text className="font-light text-gray-800 text-sm">Common Types:</Text>
        <ul className="ml-1 list-disc pl-4 text-sm">
          <li>
            <span className="font-medium">Operating Agreement</span>: For LLCs,
            defining roles, responsibilities, and ownership rules.
          </li>
          <li>
            <span className="font-medium">Corporate Bylaws</span>: For
            corporations, outlining board structure, voting processes, and
            meetings.
          </li>
          <li>
            <span className="font-medium">Partnership Agreement</span>: For
            partnerships, detailing contributions, profit-sharing, and
            decision-making.
          </li>
        </ul>
        <Text className="font-light text-gray-800 text-sm">
          These documents are essential for legal compliance, dispute
          resolution, and efficient management.
        </Text>
      </div>
    ),
  },
];
